<template>
    <div class="wrapper">
        <app-header></app-header><hr>
        <app-new-counsil></app-new-counsil>
        <!-- <app-council></app-council> -->
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Header from '@/components/layout/NewHeader';
    import Footer from '@/components/layout/NewFooter';
    // import Council from './Council';
    import NewCounsil from './NewCouncil';

    export default {
        components: {
            'app-header': Header,
            'app-footer': Footer,
            // 'app-council': Council,
            'app-new-counsil': NewCounsil,
        }

    }
</script>

<style lang="scss" scoped>
    .wrapper {
        width:100%;
        max-width: 1920px;
    }
</style>